<template>
  <v-container fluid>
    <router-view />
    Pending PractisingStatus Changes:
    <v-row>
      <v-col md12>
        <rest-resource-table
          :columns="columnHeaders"
          label="Upcoming Practicing Status Changes (next 90 days)"
          resource-name="practitioners"
          resource-id-name="id"
          :filter="upcomingFilter"
          :allow-edit="false"
          :allow-delete="false"
          :allow-new="false"
        >
          <template v-slot:item.pendingpracstatusdate="{ item }">
            <div>
              {{ item.pendingpracstatusdate | formatDate }}
            </div>
          </template>
          <template v-slot:item.person.firstname="{ item }">
            <div>
              {{ item.person.firstname }}
            </div>
          </template>
          <template v-slot:item.person.surname="{ item }">
            <div>
              {{ item.person.surname }}
            </div>
          </template>

          <template v-slot:form="{ item }">
            <public-register-preview :personId="item.id" />
            <v-btn :to="`/people/${item.id}`" type="primary">
              Open Person Record
            </v-btn>
          </template>
        </rest-resource-table>
      </v-col>
      <v-col md12>
        <rest-resource-table
          :columns="columnHeaders"
          label="Pending Practicing Status Changes"
          resource-name="practitioners"
          resource-id-name="id"
          :filter="pendingFilter"
        >
          <template v-slot:item.id="{ item }">
            <nuxt-link tag="a" :to="`/people/${item.id}`">
              {{ item.id }}
            </nuxt-link>
          </template>
        </rest-resource-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import restResourceTable from "@/components/lib/RestResourceTable.vue";
import PublicRegisterPreview from "../components/pharmacists/public-register-preview.vue";

export default {
  name: "AdminScreen",
  data() {
    return {
      pendingFilter: {
        where: {
          and: [
            {
              or: [
                { pendingpracstatusprocessed: null },
                { pendingpracstatusprocessed: false }
              ]
            },
            { pendingpracstatusprocessed: { neq: true } },
            {
              pendingpracstatusdate: {
                lt: this.$moment()
                  .endOf("day")
                  .toDate()
              }
            }
          ]
        },
        include: ["person"]
      },
      upcomingFilter: {
        where: {
          and: [
            {
              or: [
                { pendingpracstatusprocessed: null },
                { pendingpracstatusprocessed: false }
              ]
            },
            {
              pendingpracstatusdate: {
                gt: this.$moment()
                  .endOf("day")
                  .toDate()
              }
            },
            {
              pendingpracstatusdate: {
                lt: this.$moment()
                  .endOf("day")
                  .add(120, "days")
                  .toDate()
              }
            }
          ]
        },
        include: ["person"]
      },
      columnHeaders: [
        { text: "Reg Num", value: "id" },
        { text: "Name", value: "person.firstname" },
        { text: "Surname", value: "person.surname" },
        { text: "Current Status", value: "practicingstatusname" },
        { text: "Next Status", value: "pendingpracstatus" },
        { text: "Date of change", value: "pendingpracstatusdate" },
        { text: "Reason for change", value: "pendingpracstatusreason" }
      ]
    };
  },

  components: {
    restResourceTable,
    PublicRegisterPreview
  }
};
</script>
